import config from '../../config.json'
import { TeaserCard } from '../teasercard/TeaserCard'
import { TeaserCardHome } from '../teasercard/TeaserCardHome'

export const DropTeaser = ({ drop, index, isHome, isBeingDragged }) => {
    const firstTemplate = drop.templatesToMint[0]

    const { collection, verified, price, currency } = drop

    const { collectionImage, collectionName } = collection

    let { video, Video } = firstTemplate

    if (!video && Video) video = Video

    let thumbnail = ''

    const templateData = firstTemplate?.immutableData

    let img
    for (const attribute of templateData) {
        if (
            [
                'img',
                'image',
                'backimg',
                'BackingIMG',
                'backimage',
                'imgback',
                'Back',
                'img_back',
                'Back Image',
                'img back',
                'Cover',
            ].includes(attribute.key)
        ) {
            img = attribute.value[1]
        }
    }

    if (img) {
        thumbnail = `https://ipfs.hivebp.io/preview?collection=${collectionName}&size=320&hash=${img}`
        img = img.includes('http') ? img : config.ipfs + img
    }

    if (drop.isPfp) {
        try {
            if (Object.keys(drop.displayData).includes('previewImg')) {
                thumbnail = config.ipfspreviewhash
                    .replace('{collection}', collectionName)
                    .replace('{hash}', drop.displayData['previewImg'])
                    .replace('{size}', 320)
                img = thumbnail
            }
        } catch (e) {}
    }

    if (video) {
        thumbnail = `https://ipfs.hivebp.io/preview?collection=${collectionName}&size=320&hash=${video}`
        video = video.includes('http') ? video : config.ipfs + video
    }

    let name = 'Untitled'
    const displayData = drop.displayData

    if (displayData && displayData.name) {
        name =
            displayData?.name?.length > 30
                ? displayData?.name.substring(0, 30) + '...'
                : displayData?.name
    }

    return (
        <>
            {isHome ? (
                <TeaserCardHome
                    name={name}
                    author={collectionName}
                    collectionImage={collectionImage}
                    thumbnail={thumbnail}
                    verified={verified}
                    isBeingDragged={isBeingDragged}
                    image={img}
                    video={video}
                    index={index}
                    link={'/drop/' + drop.dropId}
                    price={price ? price + ' ' + currency : ''}
                    soldOut={
                        drop.maxClaimable > 0 &&
                        drop.maxClaimable <= drop.numClaimed
                    }
                    numClaimed={
                        drop.numClaimed
                            ? drop.maxClaimable > 0
                                ? Math.min(drop.maxClaimable, drop.numClaimed)
                                : drop.numClaimed
                            : 0
                    }
                    maxClaimable={drop.maxClaimable}
                    isPfp={drop.isPfp}
                />
            ) : (
                <TeaserCard
                    name={name}
                    author={collectionName}
                    collectionImage={collectionImage}
                    thumbnail={thumbnail}
                    verified={verified}
                    image={img}
                    video={video}
                    index={index}
                    link={'/drop/' + drop.dropId}
                    price={price ? price + ' ' + currency : ''}
                    soldOut={
                        drop.maxClaimable > 0 &&
                        drop.maxClaimable <= drop.numClaimed
                    }
                    numClaimed={
                        drop.numClaimed
                            ? drop.maxClaimable > 0
                                ? Math.min(drop.maxClaimable, drop.numClaimed)
                                : drop.numClaimed
                            : 0
                    }
                    maxClaimable={drop.maxClaimable}
                    isPfp={drop.isPfp}
                />
            )}
        </>
    )
}
